import React from "react";
import SharedCTASection from "../../SharedCTASection";

import qrPrint from "../../../../assets/qr_print.png";

import pdf1 from "../../../../assets/New Stickers 100mm diameter 1.pdf";
import pdf2 from "../../../../assets/New sticker 100 x 100mm 1 (1).pdf";
import pdf3 from "../../../../assets/New sticker 100 x 100mm 1.pdf";
import pdf4 from "../../../../assets/Print ready A5 flyers 1.pdf";
import pdf5 from "../../../../assets/New business cards 1.pdf";

const printItems = [
  { id: 1, pdf: pdf1, title: "new stickers 100mm diameter.pdf",    desc: "high-quality printable sticker design ready for download and use." },
  { id: 2, pdf: pdf2, title: "new sticker 100 x 100mm (1).pdf",    desc: "high-quality printable sticker design ready for download and use." },
  { id: 3, pdf: pdf3, title: "new sticker 100 x 100mm.pdf",        desc: "high-quality printable sticker design ready for download and use." },
  { id: 4, pdf: pdf4, title: "print ready a5 flyers.pdf",          desc: "high-quality printable sticker design ready for download and use." },
  { id: 5, pdf: pdf5, title: "new business cards.pdf",             desc: "high-quality printable sticker design ready for download and use." },
];

const cardStyle = {
  backgroundColor: "rgba(26,26,26,0.6)",
  border: "1px solid #5A21A8",
  borderRadius: "32px",
  backdropFilter: "blur(12px)",
  WebkitBackdropFilter: "blur(12px)",
  overflow: "hidden",
};

function PrintCard({ pdf, title, desc }) {
  return (
    <div style={cardStyle} className="flex flex-col md:flex-row w-full">
      {/* Image side */}
      <a
        href={pdf}
        target="_blank"
        rel="noopener noreferrer"
        className="flex-shrink-0 flex items-center justify-center w-full md:w-[220px] md:self-stretch"
      >
        <img
          src={qrPrint}
          alt="qr print"
          className="hover:scale-105 transition-transform duration-300 object-cover w-full h-[320px] md:h-full"
        />
      </a>

      {/* Content side */}
      <div className="flex flex-col justify-between flex-1 p-4 md:p-6 gap-3 md:gap-4">
        <div className="flex flex-col gap-2 md:gap-3">
          <p
            className="lowercase"
            style={{ fontFamily: "Inter, sans-serif", fontWeight: 700, fontSize: "clamp(14px, 3.5vw, 24px)", lineHeight: "120%", letterSpacing: "0px", color: "#FFFFFF" }}
          >
            {title}
          </p>
          <p
            className="lowercase"
            style={{ fontFamily: "Inter, sans-serif", fontWeight: 400, fontSize: "clamp(12px, 3vw, 20px)", lineHeight: "160%", letterSpacing: "0px", color: "#FFFFFF" }}
          >
            {desc}
          </p>
        </div>

        <a href={pdf} download className="w-full">
          <button
            type="button"
            className="lowercase transition-opacity hover:opacity-80 w-full"
            style={{
              height: "34px",
              borderRadius: "9999px",
              backgroundColor: "transparent",
              border: "1px solid #721AF0",
              color: "#9747FF",
              fontFamily: "Inter, sans-serif",
              fontWeight: 500,
              fontSize: "clamp(12px, 3vw, 16px)",
              paddingTop: "12px",
              paddingBottom: "12px",
              textAlign: "center",
            }}
          >
            download
          </button>
        </a>
      </div>
    </div>
  );
}

const PrintMaterials = () => (
  <>
    <section className="w-full py-16 px-4 md:px-12 lg:px-20 xl:px-28" style={{ backgroundColor: "#020013" }}>
      <div className="max-w-[1280px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
        {printItems.map((item) => (
          <PrintCard key={item.id} {...item} />
        ))}
      </div>
    </section>
    <SharedCTASection />
  </>
);

export default PrintMaterials;
